<nb-card [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-card-header [formGroup]="diaForm">
    <div class="form-inline">
      <nb-form-field fullWidth>
        <!-- <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon> -->
        <button
          nbPrefix
          nbButton
          ghost
          shape="round"
          status="info"
          size="small"
          (click)="addProduct()"
        >
          <nb-icon
            [icon]="isCreate ? 'chevron-up-outline' : 'chevron-down-outline'"
          ></nb-icon>
        </button>
        <input
          type="text"
          nbInput
          fullWidth
          shape="semi-round"
          class="form-control"
          placeholder="Nhập tên mặt hàng"
          formControlName="title"
          [(ngModel)]="strSearch"
          #title
          (keydown.enter)="onSearch()"
        />
        <button
          nbSuffix
          nbButton
          ghost
          shape="round"
          status="basic"
          size="small"
          (click)="clearSearch()"
        >
          <nb-icon nbPrefix icon="close-outline"></nb-icon>
        </button>
      </nb-form-field>
    </div>
    <div class="form-inline" *ngIf="isCreate">
      <nb-form-field>
        <input
          #createUnit
          type="text"
          nbInput
          shape="semi-round"
          class="form-control"
          style="width: 80px"
          placeholder="ĐVT"
          formControlName="unit"
          (keydown.enter)="elemFocus('createPrice')"
        />
      </nb-form-field>

      <nb-form-field>
        <input
          #createPrice
          type="text"
          nbInput
          shape="semi-round"
          class="form-control"
          style="width: 120px"
          placeholder="Giá bán"
          formControlName="price"
          (keydown.enter)="create()"
          [ngxNumberFormat]="formatCurrency"
        />
      </nb-form-field>

      <button
        type="submit"
        nbButton
        hero
        shape="semi-round"
        status="info"
        size="small"
        (click)="create()"
        [disabled]="submitted || !diaForm.valid"
        [class.btn-pulse]="submitted"
      >
        <nb-icon nbPrefix icon="save-outline"></nb-icon>
        Lưu
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <nb-list>
      <nb-list-item
        *ngFor="
          let item of display
            | paginate: { itemsPerPage: 10, currentPage: page };
          let i = index
        "
        [ngClass]="i % 2 == 0 ? 'content bg1' : 'content bg2'"
      >
        <div *ngIf="!item.editing" class="summary">
          <div class="title">
            <button
              *ngIf="!isEditing"
              nbButton
              ghost
              status="info"
              size="small"
              [disabled]="submitted"
              [class.btn-pulse]="submitted"
              [nbContextMenu]="menuItems"
              [nbContextMenuTag]="'action-buttons-' + item.id"
              (click)="loadButtonAction(item)"
            >
              <nb-icon icon="more-vertical-outline"></nb-icon>
            </button>
            <span>
              <h6 [ngClass]="item.matchFilter ? 'text-primary' : 'text-body'">
                {{ item.title }}
              </h6>
              <label class="d-flex align-items-baseline gap-2">
                <h6 class="text-danger">
                  {{ item.balanceQuantity | number }}
                </h6>
                <span *ngIf="item.unitName" class="text-hint">
                  ({{ item.unitName }})
                </span>

                <h5 class="text-info">$ {{ item.price | number }}</h5>
              </label>
            </span>
          </div>
        </div>

        <div *ngIf="!item.editing" class="button-quantity d-flex flex-column">
          <div class="form-inline mb-2">
            <nb-form-field>
              <button
                nbPrefix
                nbButton
                ghost
                (click)="productQuantityIncrement(item, -1)"
              >
                <nb-icon icon="minus-circle-outline"> </nb-icon>
              </button>
              <input
                type="number"
                nbInput
                shape="semi-round"
                class="form-control"
                placeholder="SL"
                [status]="
                  item.receiptDetail.quantity > 0 ? 'primary' : 'danger'
                "
                [(ngModel)]="item.receiptDetail.quantity"
                (change)="productQuantityChanged(item)"
              />
              <button
                nbSuffix
                nbButton
                ghost
                (click)="productQuantityIncrement(item, 1)"
              >
                <nb-icon icon="plus-circle-outline"> </nb-icon>
              </button>
            </nb-form-field>
          </div>

          <h6 class="text-success w-100">
            {{ item.receiptDetail.amount | number }}
          </h6>
        </div>

        <!-- Edit product-->
        <div *ngIf="item.editing" class="detail-editing">
          <input
            type="text"
            nbInput
            fullWidth
            shape="semi-round"
            class="form-control"
            placeholder="Nhập tên"
            [(ngModel)]="eTitle"
          />

          <div class="form-inline">
            <input
              type="text"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              placeholder="ĐVT"
              [(ngModel)]="eUnit"
            />
            <input
              type="text"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              placeholder="Nhập giá bán"
              [(ngModel)]="ePrice"
              (keydown.enter)="confirmEdit(item)"
              [ngxNumberFormat]="formatCurrency"
            />

            <div class="button-actions">
              <button
                nbSuffix
                nbButton
                hero
                status="success"
                shape="semi-round"
                size="small"
                (click)="confirmEdit(item)"
              >
                <nb-icon icon="save-outline"> </nb-icon>
              </button>

              <button
                nbPrefix
                nbButton
                outline
                shape="semi-round"
                size="small"
                nbTooltip="Hủy"
                (click)="cancelEdit(item)"
              >
                <nb-icon icon="close-circle-outline"> </nb-icon>
              </button>
            </div>
          </div>
        </div>
      </nb-list-item>
    </nb-list>
  </nb-card-body>

  <nb-card-footer>
    <div>
      <button
        nbButton
        ghost
        shape="round"
        status="warning"
        size="small"
        (click)="loadProducts()"
      >
        <nb-icon icon="sync-outline"></nb-icon>
      </button>
      <span class="text-hint"> {{ display.length }}</span>
    </div>

    <pagination-controls (pageChange)="page = $event"></pagination-controls>
  </nb-card-footer>
</nb-card>
